import React from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import Loader from "@icarius-common/loader";
import { duplicateConceptsEntryPerConceptAction, getEntryPerConcept } from "@icarius-pages/assetsDiscountsEntryPerConcept/actions";
import ReadOnlyInput from "@icarius-common/dynamicInputs/readOnlyInput";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";

const gridStyle = { height: 75, padding: "0px 10px" };

const DuplicateConceptDialog = (props) => {

  const {
    open,
    entryStructureCode,
    entryStructureName,
    selectedConceptsData,
    isLoading,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  const duplicate = (dataToSend) => {
    dispatch(duplicateConceptsEntryPerConceptAction({
      entryStructure: entryStructureCode,
      originCode: dataToSend.concept,
      ID: dataToSend.id,
      code: dataToSend.code,
      name: dataToSend.name,
    }))
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getEntryPerConcept(entryStructureCode));
          handleClose()
        }
      })
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
  } = useHandleForm(duplicate, openValidationError)

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {`${getLocalizedString("duplicateConceptInStructure")} (${entryStructureName})`}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-type`}>
                  {getLocalizedString("conceptType")}
                </InputLabel>
                <Select
                  value={formData.type}
                  labelId={`label-type`}
                  id={`select-type`}
                  onChange={(e) => setFormValue(e.target.value, "type")}
                  margin={"none"}
                >
                  {
                    Object.keys(selectedConceptsData || [])?.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item}
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={12} md={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-concept`}>
                  {getLocalizedString("originConcept")}
                </InputLabel>
                <Select
                  value={formData.concept}
                  labelId={`label-concept`}
                  id={`select-concept`}
                  onChange={(e) => setFormValue(e.target.value, "concept")}
                  margin={"none"}
                >
                  {
                    selectedConceptsData?.[formData.type]?.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.code}
                        value={item.code}
                      >
                        {item.name}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
              <ReadOnlyInput
                label={getLocalizedString("originID")}
                value={selectedConceptsData?.[formData.type]?.find((item) => item.code === formData.concept)?.ID}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
              <ReadOnlyInput
                label={getLocalizedString("employeesProcessCodigoConcepto")}
                value={selectedConceptsData?.[formData.type]?.find((item) => item.code === formData.concept)?.code}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={{ ...gridStyle, height: "", paddingTop: 20 }}>
              <Typography className="whiteText" variant="h6">
                {getLocalizedString("conceptToCreate")}:
              </Typography>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                label={"id"}
                value={formData.id}
                onChange={(e) => setFormValue(e.target.value.substring(0, 8), "id")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                label={getLocalizedString("employeesProcessCodigoConcepto")}
                value={formData.code}
                onChange={(e) => setFormValue(e.target.value.substring(0, 8), "code")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                label={getLocalizedString("employeesProcessNombreConcepto")}
                value={formData.name}
                //eslint-disable-next-line
                onChange={(e) => setFormValue(e.target.value.replace(/[^A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\/\.\(\)\%_ -]/g, "").substring(0, 40), "name")}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default DuplicateConceptDialog;